import { create } from 'zustand';
export const useRecommendedRouteStore = create((set) => ({
    setRecommendedRoute: (recommendedRoute) => {
        set(() => ({
            recommendedRoute,
        }));
    },
}));
